@if (languages.length > 1) {
  <nav role="navigation" [attr.aria-label]="'navigation.a11y.language' | translate">
    @if (isDevice$) {
      <fieldset>
        <sd-form
          select
          #languageSelector
          [items]="languages"
          valueKey="isoCode"
          libelleKey="nativeName"
          nameField="language"
          [labelTitle]="'navigation.a11y.language' | translate"
          [selectedValue]="activeIsoCode"
          (valueChanged)="changeLanguage($event)"
        />
      </fieldset>
    } @else {
      <ul sd-list-inline>
        @for (language of languages; track language.isoCode) {
          <li [attr.aria-current]="language.isoCode === activeIsoCode">
            <button
              role="button"
              [attr.tabindex]="isFocusable ? '0' : '-1'"
              class="c__btn-lang is-caption {{language.isoCode === activeIsoCode ? 'is-semi-bold' : 'is-regular'}}"
              [lang]="language.isoCode"
              [attr.aria-current]="language.isoCode === activeIsoCode"
              [attr.aria-label]="language.nativeName"
              (click)="changeLanguage(language)">
              {{ language?.isoCode?.split('_')[0] }}
            </button>
            @if (!$last && hasPipe) {
              <span>|</span>
            }
          </li>
        }
      </ul>
    }
  </nav>
}
